import { ApiEndPointsInterface, FileTypes, MenuItem, WorkspaceContentsIcons } from './@core/interfaces';
import { AnalysisAppTypes, WorkspaceDetailUIElementsInterface, WorkspaceDetailsActionIconsInterface } from './@core/interfaces';

export const INPUT_DEBOUNCE_TIME: number = 500;
export const MAX_NAME: number = 60;
export const MAX_DESCRIPTION: number = 256;
export const ROWS_PER_PAGE_OPTIONS: number[] = [25, 50, 100];

export const validationErrorMessage: { [key: string]: string } = {
  INVALID_MIN: 'Min Value Incorrect, please check again.',
  INVALID_MAX: 'Max Value Incorrect, please check again.',
  INVALID_MIN_MAX: 'Incorrect values, please check again.',
  MIN_GT_MAX: 'Min value should be less than Max.',
  EMPTY_MIN_MAX: 'Either Min or Max is missing',
};

export const ApiResponseMessages = {
  GET_WORKSPACE_ERROR: 'Could not load workspaces please try again.',
  GET_WORKSPACE_CREATOR_ERROR: 'Could not get workspace creator, please try again',
  GET_NOTEBOOK_DETAILS_ERROR: 'Could not fetch notebook details',
  GET_FILE_DETAILS_ERROR: 'Could not fetch notebook details',
  GET_PUBLIC_DASHBOARDS_ERROR: 'Could not get public dashboards list',
  WORKSPACE_CREATION_MESSAGE: 'Workspace created successfully',
  WORKSPACE_CREATION_FAILURE_MESSAGE: 'Failed to Create Workspace',
  WORKSPACE_NOT_FOUND_ERROR: 'Could not load the requested workspace, it might be deleted or you might not have access to the workspace',
};

export const ApiEndPoints: ApiEndPointsInterface = {
  GET_COMPONENTS: 'mithoo-api/components',
  GET_WORKSPACES_ENDPOINT: 'workspaces',
  GET_WORKSPACE_PERMISSIONS: 'permissions',
  GET_PROJECTS_ENDPOINT: 'projects',
  GET_FILES_ENDPOINT: 'files',
  GET_NOTEBOOKS_ENDPOINT: 'notebooks',
  GET_REPOSITORIES: 'repositories',
  GET_COMPUTE_APP_SESSION: 'compute-app-sessions',
  GET_POD_INFO: 'pod-info',
  WORKSPACE_FILTER_NAME_QUERY_PARAM: 'filter[name]',
  WORKSPACE_FILTER_STATUS_QUERY_PARAM: 'filter[status]',
  WORKSPACE_PERMISSION_QUERY_PARAM: 'include',
  WORKSPACE_META_QUERY_PARAM: 'meta',
  NOTEBOOK_DETAILS_PARAM_VALUE_V2: 'sagemaker_spec',
  WORKSPACE_PERMISSION_VALUE_USER: 'user',
  NOTEBOOK_PAGE_SIZE_VALUE: 10,
  VERSIONS_PAGE_SIZE_VALUE: 10,
  WORKSPACE_PAGE_SIZE_VALUE_MAX: 200,
  WORKSPACE_WRITE_PERMISSION_PARAM: 'filter[permission]',
  WORKSPACE_WRITE_PERMISSION_VALUE: 'manage,edit',
  USER: 'users',
  API_KEYS: 'apikeys',
  NOTIFICATIONS: 'notifications',
  ACTIVE_WORKSPACE_QUERY_PARAM: 'filter[active]',
  ACTIVE_WORKSPACE_VALUE: true,
  INPUTS: 'inputs',
  VERSIONS: 'versions',
  ITERATIONS: 'iterations',
  ALGORITHMS: 'algorithms',
  PURCHASE_LICENSE: 'polly-purchase-requests',
  INCLUDE: 'include=',
  ACTION: 'action=',
  VERSION: 'version=',
  TERMINATE: 'terminate',
  RESTORE: 'restore',
  SUCCESS: 'SUCCESS',
  AUTH_USERS: 'auth/users',
  GET_USER_APPLICATION: 'compute/app',
};

export enum InfoMessages {
  SELECT_A_FILE_MESSAGE = 'Select a file, folder or analysis to view details in this panel.',
  RESTRICTED_ACCESS = 'Only people added in this workspace can view this file.',
}

export enum WorkspaceType {
  ACTIVE_WORKSPACE_VALUE = 1,
  ARCHIVED_WORKSPACE_VALUE = 0,
}

export const API_QUERY_PARAMS = {
  SINGLE_FILE_DOWNLOAD_ACTION_VALUE: 'file_download',
  FILE_SHARE_ACTION_VALUE: 'share',
  FILE_SHARE_GLOBAL_ACTION_VALUE: 'global',
  FILE_SHARE_PRIVATE_ACTION_VALUE: 'private',
  WORKSPACES_STATUS_QUERY_PARAM: 'filter[status]',
  WORKSPACE_PAGE_SIZE_QUERY_PARAM: 'page[size]',
  WORKSPACE_PAGE_SIZE_VALUE: 20,
};

export const WORKSPACE_PERMISSIONS_MAP: {[key: string]: string} = {
  writer: 'edit',
  admin: 'manage',
  viewer: 'read',
};

export const WORKSPACE_PERMISSION_UI_MAP: {[key: string]: string} = {
  edit: 'writer',
  manage: 'admin',
  read: 'viewer',
};

export const WorkspaceContextMenu: MenuItem[] = [
  {
    action: 'information',
    icon: 'polly-icon info',
    name: 'Info',
  },
  {
    action: 'edit',
    icon: 'polly-icon edit',
    name: 'Edit Details',
  },
  {
    action: 'share',
    icon: 'polly-icon add-user',
    name: 'Share',
  },
  {
    action: 'archive',
    icon: 'polly-icon archive',
    name: 'Archive',
  }
];

export const WATCH_WORKSPACE_MENU_ITEM: MenuItem = {
  action: 'watch',
  icon: 'polly-icon visibility-on',
  name: 'Watch Workspace',
};

export const QUICK_SWITCH_WORKSPACE_MENU_ITEM: MenuItem = {
  action: 'quick-switch',
  icon: 'polly-icon swap',
  name: 'Quick Switch Workspace',
};

export const STOP_WATCHING_WORKSPACE_MENU_ITEM: MenuItem = {
  action: 'stop-watching',
  icon: 'polly-icon visibility-off',
  name: 'Stop Watching Workspace',
};

export const WorkspaceContentHeaderContextMenu: MenuItem[] = [
  {
    action: 'information',
    icon: 'polly-icon info',
    name: 'Info',
  },
  {
    action: 'edit',
    icon: 'polly-icon edit',
    name: 'Edit Details',
  },
  QUICK_SWITCH_WORKSPACE_MENU_ITEM,
  WATCH_WORKSPACE_MENU_ITEM,
  {
    action: 'archive',
    icon: 'polly-icon archive',
    name: 'Archive',
  }
];

export const ArchivedWorkspaceContextMenu: MenuItem[] = [
  {
    action: 'information',
    icon: 'polly-icon info',
    name: 'Info',
  },
  {
    action: 'restore',
    icon: 'polly-icon refresh-icon',
    name : 'Restore',
  },
  {
    action : 'delete',
    icon: 'polly-icon delete',
    name : 'Delete Permanently',
  }
];

export const WorkspaceItemContextMenu: MenuItem[] = [
  {
    action: 'rename',
    icon: '',
    name: 'Rename',
  },
  {
    action: 'edit',
    icon: '',
    name: 'Edit',
  },
  {
    action: 'download',
    icon: ``,
    name: 'Download',
  },
];

export const ViewOnlyWSItemContextMenu: MenuItem[] = [
  {
    action: 'download',
    icon: '',
    name: 'Download',
  }];

export const WorkspaceNotebookContextMenu: MenuItem[] = [
  ...WorkspaceItemContextMenu,
  {
    name: 'Clone',
    icon: '',
    action: 'clone',
  },
  {
    name: 'GitHub Download',
    icon: '',
    action: 'downloadForGithub',
  },
];

export const WorkspaceFolderContextMenu: MenuItem[] = [
  {
    name: 'Rename',
    icon: '',
    action: 'rename',
  },
];

export const AccessRights: string[] = [
  'viewer',
  'writer',
  'admin',
];

export const WorkspaceAnalysisContextMenu: MenuItem[] = [
  {
    name: 'Rename',
    icon: '',
    action: 'rename',
  },
];

export const WorkspaceFilesContextMenu: MenuItem[] = [
  {
    name: 'Rename',
    action: 'rename',
  },
  {
    name: 'Download',
    action: 'download',
  },
];

export type NotebookStatus = 'InService' | 'Pending' | 'Stopped' | 'Deleted';
export const NotebookInstance: { [key: string]: NotebookStatus } = {
  PENDING: 'Pending',
  INSERVICE: 'InService',
  STOPPED: 'Stopped',
  DELETED: 'Deleted',
}

export const FileType: FileTypes = {
  RUNS: 'analysis_v2',
  NOTEBOOK: 'notebook',
  FILE: 'file',
  FOLDER: 'folder',
};

export const AppType: AnalysisAppTypes = {
  shiny: 'shiny',
  desktop: 'desktop',
  docker: 'docker',
  calibration: 'calibration',
};

export const WORKSPACE_CONTENT_ICONS: WorkspaceContentsIcons = {
  fileIcon: 'polly-icon document',
  folderIcon: 'polly-icon folder',
  analysisIcon: 'polly-icon chart-icon',
  notebookIcon: 'polly-icon code-document',
};

export const WorkspaceDetailUIElements: WorkspaceDetailUIElementsInterface = {
  ANALYSIS: { type: 'Analysis', icon: WORKSPACE_CONTENT_ICONS.analysisIcon },
  FILE: { type: 'File', icon: WORKSPACE_CONTENT_ICONS.fileIcon },
  FOLDER: { type: 'Folder', icon: WORKSPACE_CONTENT_ICONS.folderIcon },
  NOTEBOOK: { type: 'Notebook', icon: WORKSPACE_CONTENT_ICONS.notebookIcon },
};

export const WorkspaceDetailsHeaderActionIcons: WorkspaceDetailsActionIconsInterface = {
  restore: 'polly-icon refresh',
  delete: 'polly-icon delete',
  history: 'polly-icon history',
  move: 'polly-icon pan-move',
  copy: 'polly-icon duplicate-or-copy',
  preview: 'polly-icon description',
  rename: 'polly-icon rename',
  download: 'polly-icon download-file',
  downloadForGitHub: 'polly-icon github',
  clone: 'polly-icon view-split',
};

export const POLLY_PURCHASE_LICENSE: string = 'Purchase Polly';
export const POLLY_PURCHASE_TEXT: string = `Thank you for showing interest in purchasing Polly. Please fill in the details below and our sales team will
reach out to you with more details.`;
export const POLLY_LICENSE_EXPIRED: string = 'Subscription expired';
export const POLLYPHI_DEPRECATED_TEXT: string[] = [
  'High-quality peak integration with El-MAVEN',
  'Isotope detection for C13, N15, S34 and D2 labels',
  'Natural Abundance Correction for the above-mentioned labels',
  'Customization of visualizations for corrected data',
];
export const ELUCIDATA_PRODUCT_EMAIL: string = 'product@elucidata.io';
export const POLLYPHI_WEBINAR_YOUTUBE_URL: string = 'https://www.youtube.com/watch?v=9foLye20BLA';
export const DOWNLOAD_FROM_POLLY_CLI: string =
  'It is preferable to use Polly CLI for seamless download of files greater than 100 MB in size';
export const READ_WS_PERMISSION: string = 'viewer';

export const POLLY_PRIVACY_POLICY_URL: string = 'https://www.elucidata.io/privacy-policy-11-10-2022';
export const POLLY_EULA_AGREEMENT_URL: string = 'https://www.elucidata.io/polly-eula-11-10-2022';
